import { iterateVoxelsInShape } from './iterateVoxelsInShape.js';
export function sampleVoxelsInShape(options) {
    const { voxelManager, onSample, storePointData, ...iteration } = options;
    const samples = [];
    if (!voxelManager) {
        return samples;
    }
    for (const { ijk, center } of iterateVoxelsInShape(iteration)) {
        const value = voxelManager.getAtIJKPoint(ijk);
        if (value === undefined || value === null) {
            continue;
        }
        const sample = {
            value,
            pointLPS: [center[0], center[1], center[2]],
            pointIJK: [ijk[0], ijk[1], ijk[2]],
        };
        onSample?.(sample);
        if (storePointData) {
            samples.push(sample);
        }
    }
    return samples;
}
